import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { Workbench } from '@tanium/react-workbench';
import { useRoutes } from '../../Routes';
import { OverviewPage } from '../../pages/OverviewPage';
import { useCurrentRoute } from './useCurrentRoute';
import { CMP } from '../../pages/CloudManagement/CMP';
import { Artifacts } from '../../pages/Artifacts/Artifacts';
import { EventHistorySection } from '../../pages/EventHistory/EventHistorySection';

export const AppContent: React.VFC = () => {
  const currentRoute = useCurrentRoute();
  const { WORKSPACE, ROUTES } = useRoutes();

  return (
    <Workbench
      productName={WORKSPACE.sectionName}
      homeUrl={WORKSPACE.url}
      currentPageLabel={WORKSPACE.pageName}
      breadcrumbs={[]}
      icon={WORKSPACE.icon}
      defaultSections={ROUTES}
      sections={ROUTES}
      renderedRoute={currentRoute}
    >
      <Switch>
        <Route path={'/instance'} component={CMP} />
        <Route path={'/artifacts'} component={Artifacts} />
        <Route path={'/event-history'} component={EventHistorySection} />
        <Route path={'/'} component={OverviewPage} />
      </Switch>
    </Workbench>
  );
};
